export default "__VITE_ASSET__BK34NRVj__"